export default function initializeCarousel() {
    const carouselWrappers = [...document.querySelectorAll('div.carouselblock div.wrapper')]
    if (!carouselWrappers[0]) return

    // Reset arrows.
    for (let i = 0; i < carouselWrappers.length; i++) {
        const carouselWrapper = carouselWrappers[i]
        const id = carouselWrapper.dataset.id
        const scrolledIndex = carouselWrapper.dataset.scrolledIndex
        const imagesLength = [...carouselWrapper.querySelectorAll('.carouselimage')].length

        arrowsShouldHide(0, imagesLength, scrolledIndex, id)
    }

    // Arrows
    var leftArrows = [...document.querySelectorAll('div.arrow#left')]
    var rightArrows = [...document.querySelectorAll('div.arrow#right')]

    for (let i = 0; i < leftArrows.length; i++) {
        const leftArrow = leftArrows[i]

        leftArrow.addEventListener("click", function () {
            const id = leftArrow.dataset.id
            const relatedWrapper = document.querySelector(`div.carouselblock div.wrapper[data-id="${id}"]`)
            const scrolledIndex = relatedWrapper.dataset.scrolledIndex
            const imagesLength = [...relatedWrapper.querySelectorAll('.carouselimage')].length

            scrollTo(imagesLength, scrolledIndex, 1, false, id)
        })
    }

    for (let i = 0; i < rightArrows.length; i++) {
        const rightArrow = rightArrows[i]

        rightArrow.addEventListener("click", function () {
            const id = rightArrow.dataset.id
            const relatedWrapper = document.querySelector(`div.carouselblock div.wrapper[data-id="${id}"]`)
            const scrolledIndex = relatedWrapper.dataset.scrolledIndex
            const imagesLength = [...relatedWrapper.querySelectorAll('.carouselimage')].length

            scrollTo(imagesLength, scrolledIndex, 1, true, id)
        })
    }

    // Resize
    window.onresize = function (event) {
        for (let i = 0; i < carouselWrappers.length; i++) {
            const carouselWrapper = carouselWrappers[i];
            let id = carouselWrapper.dataset.id
            let scrolledIndex = carouselWrapper.dataset.scrolledIndex
            const imagesLength = [...carouselWrapper.querySelectorAll('.carouselimage')].length

            carouselWrapper.style.transitionDuration = "0.5s";

            setTimeout(function () {
                carouselWrapper.style.transitionDuration = "1.5s";
            }, 500);

            scrollTo(imagesLength, scrolledIndex, 0, true, id)
        }
    };

    // Special case.
    handleClickIfHome()
}

/// scrollTo() requires a length, index, a value to add or subtract and a true or false to add or subtract.
function scrollTo(imagesLength, si, subtractOrAddVal, add, id) {
    const scrolledIndex = parseFloat(si)
    const CW = document.querySelector(`div.carouselblock div.wrapper[data-id="${id}"]`)
    const images = [...document.querySelectorAll('div.img-container')]

    if (scrolledIndex >= 0 && scrolledIndex <= imagesLength) {
        var imageWidth = images[0].offsetWidth;
        var translateX = 0;

        // imageWidth * imagesLength is the max length. But since its already an imageWidth wide,
        // we're subtracting that.
        var maxLength = (imageWidth * imagesLength) - imageWidth;

        if (add == true) {
            if (scrolledIndex >= imagesLength) {
                translateX = maxLength;
                CW.dataset.scrolledIndex = imagesLength - 1;
            } else {
                if (imageWidth * (scrolledIndex + subtractOrAddVal) >= maxLength) {
                    translateX = maxLength;
                    CW.dataset.scrolledIndex = imagesLength - 1;
                } else {
                    translateX = imageWidth * (scrolledIndex + subtractOrAddVal);
                    CW.dataset.scrolledIndex = scrolledIndex + subtractOrAddVal;
                }
            }
        } else {
            if (scrolledIndex <= 0) {
                translateX = imageWidth * 0;
                CW.dataset.scrolledIndex = 0;
            } else {
                translateX = imageWidth * (scrolledIndex - subtractOrAddVal);
                CW.dataset.scrolledIndex = scrolledIndex - subtractOrAddVal;
            }
        }

        CW.style.transform = "translateX(-" + translateX + "px)";

        arrowsShouldHide(0, imagesLength, CW.dataset.scrolledIndex, CW.dataset.id)
    }
}

// comment this when the arrows should be present at all times.
function arrowsShouldHide(min, max, scrolledIndex, id) {
    const leftArrow = document.querySelector(`div.arrow#left[data-id="${id}"]`)
    const rightArrow = document.querySelector(`div.arrow#right[data-id="${id}"]`)

    max = max - 1

    if (scrolledIndex == min) {
        leftArrow.style.display = "none"
    }
    if (scrolledIndex == max) {
        rightArrow.style.display = "none"
    }

    if (leftArrow.style.display == 'none' && scrolledIndex == min + 1) {
        leftArrow.removeAttribute('style')
    } else if (rightArrow.style.display == 'none' && scrolledIndex == max - 1) {
        rightArrow.removeAttribute('style')
    }
}

function handleClickIfHome() {
    const lightbox = document.querySelector('web-lightbox lb-content')
    const isHome = [...document.querySelectorAll('div.carouselblock.home')]

    if (!isHome[0]) return

    const vidURLS = ['https://player.vimeo.com/video/282627637?title=0&byline=0&portrait=0&autoplay=true', 'https://player.vimeo.com/video/323701971', 'https://player.vimeo.com/video/317439964', 'https://player.vimeo.com/video/309475038', 'https://player.vimeo.com/video/375890769', 'https://player.vimeo.com/video/349036611', 'https://player.vimeo.com/video/330058227', 'https://player.vimeo.com/video/299214020', 'https://player.vimeo.com/video/188114963?title=0&byline=0&portrait=0&autoplay=true', 'https://player.vimeo.com/video/256458833?title=0&byline=0&portrait=0&autoplay=true', 'https://player.vimeo.com/video/237541374?title=0&byline=0&portrait=0&autoplay=true', 'https://player.vimeo.com/video/201095658?title=0&byline=0&portrait=0&autoplay=true', 'https://player.vimeo.com/video/229295386?title=0&byline=0&portrait=0&autoplay=true', 'https://player.vimeo.com/video/256733102?title=0&byline=0&portrait=0&autoplay=true', 'https://player.vimeo.com/video/192899254?title=0&byline=0&portrait=0&autoplay=true', 'https://player.vimeo.com/video/119133235?title=0&byline=0&portrait=0&autoplay=true', 'https://player.vimeo.com/video/120046622?title=0&byline=0&portrait=0&autoplay=true', 'https://player.vimeo.com/video/116239923?title=0&byline=0&portrait=0&autoplay=true', 'https://player.vimeo.com/video/105667221?title=0&byline=0&portrait=0&autoplay=true', 'https://player.vimeo.com/video/85345542?title=0&byline=0&portrait=0&autoplay=true', 'https://player.vimeo.com/video/102221574?title=0&byline=0&portrait=0&autoplay=true', 'https://player.vimeo.com/video/58975730?title=0&byline=0&portrait=0&autoplay=true', 'https://player.vimeo.com/video/100711858?title=0&byline=0&portrait=0&autoplay=true', 'https://player.vimeo.com/video/100711859?title=0&byline=0&portrait=0&autoplay=true', 'https://player.vimeo.com/video/58975728?title=0&byline=0&portrait=0&autoplay=true', 'https://player.vimeo.com/video/100711855?title=0&byline=0&portrait=0&autoplay=true', 'https://player.vimeo.com/video/120776270?title=0&byline=0&portrait=0&autoplay=true', '', 'https://player.vimeo.com/video/58975733?title=0&byline=0&portrait=0&autoplay=true', 'https://player.vimeo.com/video/85341472?title=0&byline=0&portrait=0&autoplay=true', 'https://player.vimeo.com/video/59065106?title=0&byline=0&portrait=0&autoplay=true', 'https://player.vimeo.com/video/58975729?title=0&byline=0&portrait=0&autoplay=true', 'https://player.vimeo.com/video/58975136?title=0&byline=0&portrait=0&autoplay=true']

    for (let i = 0; i < isHome.length; i++) {
        const carouselblock = isHome[i];

        const images = [...carouselblock.querySelectorAll('div.img-container')]

        const node = document.createElement('iframe')
        node.width = '100%'
        node.height = '100%'
        node.frameBorder = '0'
        node.allowFullscreen = 'allowfullscreen'

        for (let i = 0; i < images.length; i++) {
            const image = images[i];
            image.addEventListener('click', (e) => {
                node.src = vidURLS[i]

                lightbox.parentElement.classList.add('active')
                lightbox.appendChild(node)
            })
        }
    }
}
